import { canonical } from '@verlo/shared/lib/allergens';

// A dish's allergens worked out from its recipe (D12, Back office sweep Oct 2026). Each line is
// an ingredient or a sub-recipe; `allergensOf(line)` is what's recorded for it: a list (maybe
// empty, meaning none), or null when nobody has said yet.
export function fromRecipe(lines, allergensOf) {
  const has = new Set();
  const unknown = [];
  for (const line of lines || []) {
    const a = allergensOf(line);
    if (a == null) unknown.push(line.name);
    else canonical(a).forEach((k) => has.add(k));
  }
  return { has: canonical([...has]), unknown };
}

// Where the recipe and the dish's own list disagree: what the ingredients have that the dish
// doesn't list (the dangerous way round), and what the dish lists that no ingredient has.
export function compareWithDish(fromIngredients, dishAllergens) {
  const dish = new Set(canonical(dishAllergens));
  const ing = new Set(fromIngredients);
  return {
    notOnDish: fromIngredients.filter((k) => !dish.has(k)),
    notInRecipe: [...dish].filter((k) => !ing.has(k)),
  };
}
